/**
 * Team persistence helpers using IndexedDB.
 */

import type { Team } from "../engine/types";
import { DB_STORES, COOKIE_KEYS, FORMAT } from "../config/constants";
import { dbGetAll, dbPut, dbDelete, dbGet } from "./db";
import { getCookie, setCookie } from "../ui/utils/cookies";

export async function saveTeam(team: Team): Promise<void> {
  team.updatedAt = new Date().toISOString();
  await dbPut(DB_STORES.TEAMS, team);
}

export async function getAllTeams(): Promise<Team[]> {
  return dbGetAll<Team>(DB_STORES.TEAMS);
}

export async function getTeam(id: string): Promise<Team | undefined> {
  return dbGet<Team>(DB_STORES.TEAMS, id);
}

export async function deleteTeam(id: string): Promise<void> {
  await dbDelete(DB_STORES.TEAMS, id);
}

export function getLastTeamId(): string | null {
  return getCookie<string | null>(COOKIE_KEYS.LAST_TEAM, null);
}

export function setLastTeamId(id: string): void {
  setCookie(COOKIE_KEYS.LAST_TEAM, id);
}

export function createEmptyTeam(name = "New Team"): Team {
  const now = new Date().toISOString();
  return {
    id: crypto.randomUUID(),
    name,
    format: FORMAT,
    members: [],
    createdAt: now,
    updatedAt: now,
  };
}